export enum ApplicationType {
  Web = "Web",
  Tyler = "TAP",
  ServiceNow = "SN"
}

interface IProjectCardProps {
  projectType: number; // 1 = Web, 2 = FedRamp/Tyler
  projectName: string;
  clientName?: string; // Optional
  dateDisplay: string; // e.g., "Updated 3 hours ago" or "Created 2 days ago"
  applicationType: ApplicationType; // Web | Tyler
  projectId: string; // For callbacks
  onClick?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onClone?: () => void;
  onStats?: () => void;
  onManageCollaborations?: () => void;
  isCloning?: boolean;
  deleteLoading?: boolean;
  className?: string;
  // Shared project information
  sharedBy?: string; // Name or email of the person who shared the project
  role?: string; // User's role in the shared project (e.g., "Editor", "Viewer")
  onLeave?: () => void; // Callback for leaving a shared project
  isLeaving?: boolean; // Loading state for leave action
  // Invitation actions
  isInvitation?: boolean; // Whether this is a pending invitation
  onAccept?: () => void; // Callback for accepting invitation
  onDecline?: () => void; // Callback for declining invitation
  isAccepting?: boolean; // Loading state for accept action
  isDeclining?: boolean; // Loading state for decline action
}

export type {
  IProjectCardProps
};

